import {
    Component,
    ComponentFactoryResolver,
    OnInit,
    ViewChild,
    ViewContainerRef,
    ViewEncapsulation
} from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ScriptLoaderService } from '../../../_services/script-loader.service';
import { LoginCustom } from '../../_helpers/login-custom';
import { Helpers } from '../../../helpers';
import { AlertComponent } from '../../_directives';
import { PublisherUserAuthenticationService } from '../_services';
import { SweetAlertService } from '../../../_services/sweetalert.service';

@Component({
    selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
    templateUrl: './change-password.component.html',
    encapsulation: ViewEncapsulation.None
})
export class PublisherUserChangePasswordComponent implements OnInit {
    model: any = {};
    loading = false;
    key: any = {};
    email: any = {};

    @ViewChild('alertSignin', { read: ViewContainerRef })
    alertSignin: ViewContainerRef;
    @ViewChild('alertSignup', { read: ViewContainerRef })
    alertSignup: ViewContainerRef;
    @ViewChild('alertForgotPass', { read: ViewContainerRef })
    alertForgotPass: ViewContainerRef;

    constructor(
        private _router: Router,
        private route: ActivatedRoute,
        private _script: ScriptLoaderService,
        private cfr: ComponentFactoryResolver,
        private authService: PublisherUserAuthenticationService,
        private _alertService: SweetAlertService
    ) { }

    ngOnInit() {
        this._script
            .loadScripts(
            'body',
            [
                'assets/vendors/base/vendors.bundle.js',
                'assets/demo/demo7/base/scripts.bundle.js'
            ],
            true
            )
            .then(() => {
                Helpers.setLoading(false);
                LoginCustom.init();
            });

        this.route.queryParams.subscribe(params => {
            this.key = params['pToken'];
            this.email = params['email'];
        });
    }

    changePassword() {
        var _self = this;
        if (this.key === undefined) {
            this._alertService.error('password token is undefined!');
            return;
        }
        if (this.email === undefined) {
            this._alertService.error('email is undefined!');
            return;
        }

        if (this.model.password != this.model.password2) {
            this._alertService.error('password and repassword are not the same !');
            return;
        }
        Helpers.setLoading(true);

        this.authService
            .changePassword(this.email, this.key, this.model.password)
            .subscribe(
            data => {
                Helpers.setLoading(false);
                this._alertService.success('password changed successfully.');
                setTimeout(function() {
                    _self._router.navigate(['/publisher']);
                }, 1000);
            },
            error => {
                Helpers.setLoading(false);

                this._alertService.error(error);
                this.loading = false;
            }
            );
    }

    showAlert(target) {
        this[target].clear();
        let factory = this.cfr.resolveComponentFactory(AlertComponent);
        let ref = this[target].createComponent(factory);
        ref.changeDetectorRef.detectChanges();
    }
}



// WEBPACK FOOTER //
// /Users/creative/Documents/GitHub/makrooreservation/src/ui/src/app/auth/publisher-user/change-password/change-password.component.ts